import { LazyLoadImage } from 'react-lazy-load-image-component';
import Skeleton from 'react-loading-skeleton';
import cx from 'classnames';
import { useState } from 'react';
import dynamic from 'next/dynamic';

import { toPX } from '#app/helpers/toPX';
import useWindowSize from '#app/hooks/useWindowSize';

import styles from './index.module.scss';

const PlayIcon = () => (
  <svg
    width="43"
    height="55"
    viewBox="0 0 43 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M43 27.4337L0.249997 54.6562L0.25 0.21121L43 27.4337Z" fill="white" />
  </svg>
);

const ReactPlayer = dynamic(() => import('react-player'), { ssr: false });

const ImageText = ({
  icon,
  first = 'image',
  header,
  footer,
  image,
  video,
  maxWidth,
  children,
  className,
  classNameWrapper,
  classNameImage,
  classNameText,
  classNameFooter
}) => {
  const { isDesktop } = useWindowSize();
  const [playState, setPlayState] = useState(false);

  return (
    <section className={cx(classNameWrapper, styles.wrapper)}>
      <div
        className={cx(className, styles.container, {
          [styles.container__first_text]: first === 'text' && !header && !footer,
          [styles.container__first_image]: first === 'image' && !header && !footer,
          [styles.container__first_text__header]: first === 'text' && header && !footer,
          [styles.container__first_image__header]: first === 'image' && header && !footer,
          [styles.container__first_text__footer]: first === 'text' && footer && !header,
          [styles.container__first_image__footer]: first === 'image' && footer && !header,
          [styles.container__first_text__both]: first === 'text' && header && footer,
          [styles.container__first_image__both]: first === 'image' && header && footer
        })}
        style={{ maxWidth: maxWidth, width: maxWidth }}
      >
        {/* Header */}
        {header && <div className={styles.header}>{header}</div>}

        {/* Image | Video */}
        <div
          className={cx(video && video.className, image && image.className, styles.image)}
          onClick={() => video && setPlayState(true)}
        >
          {image && (
            <LazyLoadImage
              effect="blur"
              alt="preview"
              width={image.width && toPX(isDesktop, image.width)}
              height={image.height && toPX(isDesktop, image.height)}
              src={isDesktop ? image.image[0] : image.image[1]}
              placeholder={<Skeleton width="100%" height="100%" />}
            />
          )}

          {video && (
            <ReactPlayer
              url={`https://www.youtube.com/watch?v=${video.youtubeId}&ab_channel=CrackTheCode`}
              playing={playState}
              light
              volume={0.5}
              width={video.width && toPX(isDesktop, video.width)}
              height={video.height && toPX(isDesktop, video.height)}
              playIcon={
                <div className={styles.image_play}>
                  <PlayIcon />
                </div>
              }
            />
          )}
        </div>

        {/* Text */}
        <div className={cx(classNameText, styles.text)}>{children}</div>

        {/* Footer */}
        {footer && <div className={cx(classNameFooter, styles.footer)}>{footer}</div>}
      </div>
      {icon && (
        <div className={styles.icon}>
          <img src={icon} alt="icono" />
        </div>
      )}
    </section>
  );
};

export default ImageText;
